import type User from '../../../features/auth/domain/auth';

export interface ApiUserProfile {
    message: string;
    data: User;
}


//  Not used for now
const apiUserProfileToUserProfile = (apiUserProfile: User): User => {
    const { id, firstName, hasConsented, lastName, email, ref, location: location, hasHandicapCard, profilePic, phoneNumber, language, birthdate } = apiUserProfile;
    const { additional, zipcode, city, street, country } = location || {};

    return {
        birthdate,
        email,
        firstName,
        hasHandicapCard,
        id,
        hasConsented,
        language,
        lastName,
        location: {
            additional,
            city: city || '',
            country: country || '',
            street: street || '',
            zipcode: zipcode || ''
        },
        phoneNumber,
        profilePic,
        ref
    };
};

const userToApiUserProfile = (user: User): User => {
    const { firstName, lastName, location, hasHandicapCard, profilePic, phoneNumber, language, hasConsented, birthdate } = user;
    const { additional, zipcode, city, street, country } = location || {};

    return {
        birthdate,
        firstName,
        hasHandicapCard,
        language,
        lastName,
        location: {
            additional,
            city: city || '',
            country: country || '',
            street: street || '',
            zipcode: zipcode || ''
        },
        hasConsented,
        phoneNumber,
        profilePic
    };
};


const useUserConvertor = {
    apiUserProfileToUserProfile,
    userToApiUserProfile
};

export default useUserConvertor;
